import ApplicationController from '../application_controller'

class EditFormController extends ApplicationController {
  static targets = ['activeTab']
  static values = { activeTab: String }

  connect () {
    this.setCurrentTab()

    const tabElement = document.querySelector('button[data-bs-toggle="tab"], a[data-bs-toggle="tab"]')
    tabElement?.addEventListener('shown.bs.tab', function (event) {
      const anchor = event.target.dataset.bsTarget
      const activeTab = document.getElementById('active_tab')
      if (activeTab) document.getElementById('active_tab').value = anchor
    })

    const triggerTabList = [].slice.call(document.querySelectorAll('button[data-bs-toggle="tab"]'))
    triggerTabList.forEach(function (triggerEl) {
      const tabTrigger = new bootstrap.Tab(triggerEl)

      triggerEl.addEventListener('click', function (event) {
        event.preventDefault()
        tabTrigger.show()
      })
    })
  }

  setCurrentTab = () => {
    const anchor = this.activeTabValue || '#' + window.location.hash.substring(1)
    const triggerElement = document.querySelector('button[data-bs-target="' + anchor + '"]')
    triggerElement && new bootstrap.Tab(triggerElement).show()
    window.history.replaceState(null, '', `${window.location.pathname}${this.activeTabValue}`)
  }
}

export default EditFormController
